<template>
  <div class="page-content unaccredit">
    <section class="seaerch-wrapper">
      <headerSearch
        @searchTable="searchTable"
        @firstGetSearch="firstGetSearch"
        :dealState="true"
        :productShow="true"
        :dealerShow="false"
        ref="refheader"
        :unauthorizative="true"
      >
        <template slot="searchSort">
          <el-form-item></el-form-item>
          <el-form-item></el-form-item>
        </template>
      </headerSearch>
    </section>
    <section class="seaerch-wrapper">
      <!-- 表格 -->
      <div>
        <div>
          <el-button
            size="small"
            class="search-btn1"
            @click="batchDel(1)"
            :disabled="batchDealStatus"
            type="primary"
            v-if="type.editStatus"
          >批量处理违规</el-button>

          <el-button size="small" class="search-btn1" @click="batchDel(2)" v-if="type.editStatus">批量删除</el-button>
          <el-button size="small" class="search-btn1" @click="downLoad">下载数据</el-button>
        </div>
        <tableHeader
          :selectAll="true"
          ref="tableDown"
          :downShow="false"
          :chekTableNum="{'all':totalPage,check:checkNum}"
          :headerShow="true"
          @allCheck="toggleSelection(tableData,'true')"
          @cancelAllCheck="toggleSelection()"
          class="margin_bottom5"
        ></tableHeader>
        <el-table
          ref="multipleTable"
          header-row-class-name="data-table-header-style"
          :data="tableData"
          style="width: 100%"
          @selection-change="selectionChange"
          @row-click="showInfoStatus"
          v-loading="normaltableLoading"
          element-loading-spinner="el-icon-loading"
          element-loading-text="拼命加载中"
        >
          <el-table-column type="selection" width="60" ></el-table-column>
          <el-table-column label="序号" width="60" type="index"></el-table-column>
          <el-table-column label="违规信息">
            <template slot-scope="scope">
              <delReportInfo :info="scope.row"></delReportInfo>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="处理状态/备注" width="350">
            <template slot-scope="scope">
              <delStatusInfo :info="scope.row"></delStatusInfo>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200" v-if="type.editStatus">
            <template slot-scope="scope">
              <div style="cursor: pointer">
                <span @click.stop="dealRow(scope.row)">
                  <i class="el-icon-delete color_blue"></i>
                  <span class="color_blue">删除</span>
                </span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 提示 -->
        <elementHint
          ref="hintCommon"
          :main2="hint.main2"
          :redMain="hint.redMain"
          :main="hint.main"
          @hintConfire="hintConfire"
          @closeHint='cancelCheck'
        ></elementHint>
      </div>

      <Pagination
        @onChange="getReportExamine"
        class="pagination"
        :total="totalPage"
        :pagination="pagination"
        :pagesizes="pagesizes"
        style="text-align:right;margin:20px 0;"
      />
      <rightInfo ref="refrightInfo" :reportid="reportid" @loadList="searchTable"></rightInfo>
      <el-dialog
        title="批量处理违规"
        :visible.sync="dealProcessing"
        width="430px"
        class="illegalProcessing"
      >
        <el-form label-width="90px" class="modalForm">
          <el-form-item label="处理方式:" :required="true">
            <el-select v-model="deal.result" size="small">
              <el-option v-for="item in dealList" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="处理说明：" style="margin-bottom:0;">
            <el-input
              size="small"
              type="textarea"
              maxlength="200"
              placeholder="请输入说明，请保持在200字以内。"
              v-model="deal.decisions"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button type="confire_btn" @click="handleCancel" size="small">确 定</el-button>
          <el-button @click="dealProcessing=false" size="small">取 消</el-button>
        </div>
      </el-dialog>
    </section>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
import { fetchGet, fetchPost, fetchGetDown } from "@/libs/reqCommon";
import Pagination from "components/pagination/pagination";
import headerSearch from "../common/headerSearch";
import rightInfo from "./rightInfo";
import { getLoginType } from "@/libs/until";
import delReportInfo from "../common/delReportInfo";
import tableHeader from "../common/tableHeader"; //表头
import elementHint from "components/dataTable/elementHint"; //提示
import delStatusInfo from "../common/delStatusInfo";
export default {
  data() {
    return {
      batchDealStatus:true,
      normaltableLoading:true,
      checkNum: 0,
      dealProcessing: false,
      formLabelWidth: "100px",
      pagination: {
        size: 10,
        current: 1
      },
      deal: {},
      tableData: [],
      selectRow:[],
      singleRow:[],
      pagesizes: [10, 20, 50, 100],
      totalPage: 0,
      reportid: "",
      logintype: getLoginType(),
      dealList: ["通知店铺整改", "知识产权投诉"],
      hint: {
        main: "你确认要删除该违规信息吗？",
        redMain: "违规信息将无法恢复",
        main2: "删除后"
      },
      type: {}
    };
  },
  components: { Pagination, headerSearch, rightInfo,delReportInfo,elementHint,tableHeader,delStatusInfo },
  computed: {
    ...mapState({
      creditSearchData: state => state.creditScore.creditSearchData
    })
  },
  mounted() {
    this.type = JSON.parse(window.localStorage.userData)
  },
  created() {
    this.normaltableLoading=true
  },
  methods: {
    ...mapActions(["getById"]),
    ...mapMutations(["commonHeaderSearch"]),
    cancelCheck(){
      this.singleRow=[]
      this.hint.hintShow=false
      console.log(this.selectRow)
    },
    batchDel(type) {
      if (this.selectRow.length === 0) {
        this.$message.error("没有选择项");
        return false;
      }
      if (type == 1) {
        // 批量处理违规
        this.batchDeal(this.getCheckId())
      }
      if (type == 2) {
        //批量删除
        this.hint = {
          main: "你确认要删除该违规信息吗？",
          redMain: "违规信息将无法恢复",
          main2: "删除后"
        };
        this.$refs.hintCommon.ifsee();
      }
      this.singleDel = false;
    },
    dealRow(row) {
      this.$refs.hintCommon.ifsee();
      this.singleDel = true;//判断是否是单条删除
      this.singleRow = [row];
    },
    getCheckId() {
      //获取勾选的id
      let id = [];
      if (this.checkAll) {
        //全部勾选
        id = ["checkAll"];
      } else {
        this.selectRow.forEach(item => {
          if(!item.result){
             id.push(item.id);
          }
        });
      }
      return String(id);
    },
    hintConfire() {
      //删除
      let ids = [];
      let reportid = [];
      let flowids = [];
      if (this.checkAll) {
        //全部勾选
        ids = ["checkAll"];
      } else {
        let rowFull=this.singleDel?this.singleRow: this.selectRow
        rowFull.forEach(item => {
          ids.push(item.id);
          let delstatus = item.result ? 12 : 11;
          flowids.push(delstatus);
        });
      }
      let data = {
        ids: String(ids),
        ...this.getCommonSearch(),
        flowids: String(flowids)
      };
      fetchPost("hcm/hcmReport/Delete", data).then(res => {
        if (res.status == "10000") {
          this.$message({ type: "success", message: "删除成功" });
          this.$refs.multipleTable.clearSelection();
          this.selectRow = [];
          this.checkAll = false;
          this.searchTable()
        } else {
          this.$message({ type: "warning", message: res.message });
        }
        this.$refs.hintCommon.closeifsee();
      });
    },
    async showInfoStatus(row) {
       await this.getById(row.reportid);
        this.showInfo(row.reportid)
    },
    toggleSelection(rows, all) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row, true);
        });
      } else {
        //取消勾选
        this.$refs.multipleTable.clearSelection();
      }
      if (all) {
        this.checkAll = true;
        this.checkNum = this.totalPage;
        this.batchDealStatus=this.getCommonSearch().result==12?true:false
      } else {
        this.checkAll = false;
        this.checkNum = 0;
        this.batchDealStatus=true
      }
    },
    selectionChange(row) {
      this.checkAll = false;
      this.selectRow = row;
      this.checkNum = row.length;
       this.batchDealStatus=true
      row.map(item=>{
        if(!item.result){
           this.batchDealStatus=false
        }
      })
    },
    firstGetSearch(data) {
      this.commonHeaderSearch(data);
      this.getReportExamine();
    },
    async handleCancel() {
      //批量处理违规
      if (!this.deal.result) {
        this.$message.error("请选择处理结果");
        return false;
      }
      fetchPost("/hcm/hcmReport/handleInstall", {
        ...this.getCommonSearch(),
        ...this.deal,
        id: this.batchId
      })
        .then(res => {
          if (res.status === "10000") {
            this.$message.success("成功");
            this.dealProcessing = false;
            this.deal = {};
            this.searchTable();
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(() => {
          this.$message.error("失败");
        });
    },
    batchDeal(id) {
      this.batchId = id;
      if (this.tableData) {
      }
      this.dealProcessing = true;
    },
    downLoad() {
      let data = this.getCommonSearch();
      delete data.flowids;
      fetchGetDown(
        "hcm/hcmReport/downloadReportBlackPage",
        data,
        "非授权违规处理"
      );
    },
    showInfo(reportid) {
      this.reportid = reportid;
      this.$refs.refrightInfo.ifshow = true;
      this.$refs.refrightInfo.activeName = "first";
      this.$refs.refrightInfo.echoDeal();
    },
    searchTable() {
      this.normaltableLoading=true
      // this.pagination.current = 1;
      // this.pagination.size = 10;
      this.getReportExamine();
    },
    getCommonSearch() {
      let data = {
        type: 2,
        ...this.creditSearchData,
        result: this.creditSearchData.flowids
          ? this.creditSearchData.flowids
          : ""
      };
      delete data.flowids;
      console.log(data)
      return data;
    },
    getReportExamine() {
      fetchGet("/hcm/hcmReport/getReportBlackPage", {...this.getCommonSearch(), pageNo: this.pagination.current,
        pageSize: this.pagination.size,})
        .then(res => {
          this.normaltableLoading=false
          if (res.status === "10000") {
            res.data.content.map(item => {
              if (item.result && item.result != '0') {
                item.status = 12;
              } else {
                item.status = 11;
              }
            });
            this.tableData = res.data.content;
            this.totalPage = res.data.totalElements;
            this.$emit("change", this.totalPage);
          }
        })
        .catch(() => {
          this.normaltableLoading=false
        });
    }
  }
};
</script>
<style lang="scss">
@import "src/style/tableCommon";
@import "src/style/fontSize";

.unaccredit {
  .el-drawer {
    background-color: rgba(240, 242, 245, 1) !important;
  }
  .el-drawer-credit .el-drawer__header {
    background-color: white;
  }
  .commonReport {
    padding: 1px;
  }
  .el-icon-delete{
    margin-right: 5px;
  }
}
</style>
